"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAutoListener = exports.ObjectPool = exports.colorByte = exports.setByte = exports.getByte = exports.setItems = exports.ratio = exports.createBinarySearch = exports.gard = exports.assert = exports.findex = void 0;
function findex(list, i) {
    if (i < 0)
        i += list.length;
    return list[i];
}
exports.findex = findex;
function assert(x) {
    if (x === undefined || x === null)
        throw new Error("Assertion of not null and undefined failed");
    return x;
}
exports.assert = assert;
function gard(x, d) {
    if (x === undefined || x === null)
        return d;
    return x;
}
exports.gard = gard;
function createBinarySearch(getItem) {
    /**
     * return the index of the largest element equal or smaller than target
     */
    return new Function("list", "target", `
        let length = list.length
        if (length <= 0) return -1
        let l = 0
        let r = length - 1
        if (target < ${getItem("list", "l")}) return -1
        if (${getItem("list", "r")} <= target) return r

        while (l < r - 1) {
            const m = ((l + r) / 2) | 0
            const v = ${getItem("list", "m")}
            if (target < v) r = m
            else if (v < target) l = m
            else return m
        }
        return l`);
}
exports.createBinarySearch = createBinarySearch;
function ratio(start, end, target, from, to) {
    const r = (target - start) / (end - start);
    return (to - from) * r + from;
}
exports.ratio = ratio;
function setItems(s) {
    const list = [];
    let i = 0;
    for (const item of s) {
        list[i++] = item;
    }
    return list;
}
exports.setItems = setItems;
function getByte(number, byte) {
    const off = (byte | 0) * 8;
    const mask = 0xff << off;
    return (number & mask) >> off;
}
exports.getByte = getByte;
function setByte(number, byte, value) {
    const off = (byte | 0) * 8;
    const v = (value & 0xff) << off;
    const imask = ~(0xff << off);
    number = (number & imask) | v;
    return number;
}
exports.setByte = setByte;
exports.colorByte = {
    r: 2,
    g: 1,
    b: 0,
};
class ObjectPool {
    constructor(newObj, beforeGet, beforeSave) {
        this.newObj = newObj;
        this.beforeGet = beforeGet;
        this.beforeSave = beforeSave;
        this.pool = [];
    }
    get() {
        if (!this.newObj)
            throw new Error("Can not create new object");
        if (this.pool.length <= 0) {
            this.pool.push(this.newObj());
        }
        const v = this.pool.pop();
        if (this.beforeGet)
            this.beforeGet(v);
        return v;
    }
    save(o) {
        if (this.beforeSave)
            this.beforeSave(o);
        this.pool.push(o);
    }
    ensure(n) {
        if (!this.newObj)
            throw new Error("Can not create new object");
        while (this.pool.length < n)
            this.pool.push(this.newObj());
    }
    destroy() {
        this.pool.length = 0;
    }
}
exports.ObjectPool = ObjectPool;
function addAutoListener(element, event, listener) {
    const wrap = (ev) => {
        const remove = () => element.removeEventListener(event, wrap);
        listener(remove, ev);
    };
    element.addEventListener(event, wrap);
    return () => element.removeEventListener(event, wrap);
}
exports.addAutoListener = addAutoListener;
//# sourceMappingURL=Utils.js.map